export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN; // eslint-disable-line no-undef
export const FACEBOOK_APP_ID = process.env.REACT_APP_FB_APP_ID; // eslint-disable-line no-undef

export const BASIC_CHALLENGE_LIMIT = 25;
export const BASIC_TEAM_LIMIT = 20;
export const ENHANCED_CHALLENGE_LIMIT = 100;
export const ENHANCED_TEAM_LIMIT = 100;
export const ENHANCED_PRICE = 79;
